import * as React from 'react';

export class BasePopupMenuIcon extends React.Component<{src: string, size?: number}, {}> {
    public render(): JSX.Element {
        const size: number = this.props.size ? this.props.size : 20;
        return (
            <div
                style={{
                    alignContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    height: size,
                    left: 10,
                    position: 'absolute',
                    top: 'calc(50% - ' + (size / 2) + 'px)',
                    width: size,
                    zIndex: -1
                }}
            >
                <img
                    style={{
                        maxWidth: size,
                        maxHeight: size,
                        width: 'auto',
                        height: 'auto'
                    }}
                    src={this.props.src}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/BasePopupMenuIcon.tsx